export default __webpack_public_path__ + "static/media/review.0d8c18b3.jpg";